<template>
  <div class="p-3 mb-5">
    <div class="d-flex justify-content-center">
      <div class="card w-100">
        <div class="card-header bg-main text-white h4 text-center position-relative">
          <strong>CONSUMOS</strong>
          <button type="button"
            class="btn btn-outline-main position-absolute end-0 top-50 translate-middle-y me-3 text-white"
            @click="returnHome">
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>

        <div class="card-body w-100">
          <div class="row">
            <!-- FECHA DESDE -->
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
              <div class="input-group input-group-sm">
                <span class="input-group-text">Desde</span>
                <input type="date" class="form-control" v-model="filter.begindate" />
              </div>
            </div>

            <!-- FECHA HASTA -->
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
              <div class="input-group input-group-sm">
                <span class="input-group-text">Hasta</span>
                <input type="date" class="form-control" v-model="filter.enddate" />
              </div>
            </div>

            <!-- BOTÓN BUSCAR -->
            <div class="col-12 col-md-4 col-lg-2 col-xl-2 text-center">
              <button type="button" class="btn btn-sm btn-register text-white w-100" @click="mtdGetData">
                <i class="fas fa-search"></i> Buscar
              </button>
            </div>

            <!-- BUSCADOR -->
            <div class="col-12 col-md-6 col-lg-4 col-xl-4">
              <div class="input-group input-group-sm">
                <span class="input-group-text">Buscar</span>
                <input type="text" class="form-control" placeholder="Nombre" v-model="filter.search" />
              </div>
            </div>
          </div>

          <!-- BOTONES EXPORTAR -->
          <div class="row mt-2" v-if="filteredData.length > 0">
            <div class="col-12 d-flex gap-2 justify-content-end">
              <button type="button" class="btn btn-sm btn-success text-white" @click="exportExcel"
                :disabled="loading.excel">
                <i class="fas fa-file-excel"></i>
                {{ loading.excel ? 'Generando...' : 'Excel' }}
              </button>
              <button type="button" class="btn btn-sm btn-danger text-white" @click="exportPDF" :disabled="loading.pdf">
                <i class="fas fa-file-pdf"></i>
                {{ loading.pdf ? 'Generando...' : 'PDF' }}
              </button>
              <button type="button" class="btn btn-sm btn-secondary text-white" @click="printTable">
                <i class="fas fa-print"></i> Imprimir
              </button>
            </div>
          </div>

          <!-- TABLA -->
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-2">
            <div class="table-container">
              <table id="consumos-table" class="table table-bordered border-main align-middle">
                <thead class="header-sticky">
                  <tr class="text-center text-white font-size-ca" style="background: #900052; vertical-align: middle">
                    <th>N°</th>
                    <th>NOMBRE</th>
                    <th>FORMA FARM.</th>
                    <th>MARCA</th>
                    <th>MOLECULA</th>
                    <th>COMERCIAL</th>
                    <th>PRESENTACION</th>
                    <th>STOCK GENERAL</th>
                    <th>DESPACHOS</th>
                    <th>DEVOLUCIONES</th>
                    <th>CONSUMOS</th>
                    <th class="no-print">VER DESPACHOS Y DEVOLUCIONES</th>
                  </tr>
                </thead>

                <tbody class="custom-table">
                  <tr v-if="filteredData.length == 0">
                    <td class="text-center align-middle" colspan="12">
                      {{ noRecordsMessage }}
                    </td>
                  </tr>

                  <tr v-for="(item, index) in filteredData" :key="index">
                    <td class="text-center align-middle">{{ index + 1 }}</td>

                    <td class="text-center align-middle">
                      {{ item.product?.subsubcategorie?.name || "-" }}
                    </td>

                    <td class="text-center align-middle">
                      {{ item.product?.subsubcategorie?.group?.name || "Sin Forma" }}
                    </td>

                    <td class="text-center align-middle">
                      {{ item.product?.brand?.name || "-" }}
                    </td>

                    <td class="text-center align-middle">
                      {{ item.product?.molecule || "-" }}
                    </td>

                    <td class="text-center align-middle">
                      {{ item.product?.commercial || "-" }}
                    </td>

                    <td class="text-center align-middle">
                      {{ item.product?.presentation || "-" }}
                    </td>

                    <td class="text-center align-middle">
                      {{ getStock(item) }}
                    </td>

                    <td class="text-center align-middle">
                      {{ item.avg_quantity || 0 }}
                    </td>

                    <td class="text-center align-middle">
                      {{ item.avg_devolution || 0 }}
                    </td>

                    <td class="text-center align-middle">
                      {{ (item.avg_quantity || 0) - (item.avg_devolution || 0) }}
                    </td>

                    <td class="text-center align-middle no-print">
                      <div class="d-flex justify-content-center">
                        <a class="acciones-5 text-center px-2 py-2 bg-info" title="Ver despachos y devoluciones"
                          href="javascript:void(0)" style="margin-left: 2px"
                          @click="openModalViewDispatch(item.product?.id, index)">
                          <i class="fas fa-eye text-white"></i>
                        </a>
                      </div>
                    </td>
                  </tr>

                  <tr v-if="filteredData.length > 0" style="background: #f5e6ee; font-weight: bold">
                    <td colspan="7" class="text-end">TOTAL</td>
                    <td class="text-center align-middle color-main">{{ totals.quantity }}</td>
                    <td class="text-center align-middle color-main">{{ totals.devolution }}</td>
                    <td class="text-center align-middle color-main">{{ totals.consumed }}</td>
                    <td class="no-print"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- FIN TABLA -->
        </div>
      </div>
    </div>

    <cModalViewDispatch :title="modalViewDispatch.title" :boo_modal="modalViewDispatch.modal_form"
      :data="modalViewDispatch.data" @mtdCloseModalViewDispatch="mtdCloseModalViewDispatch" />
    <SweetAlert :swal="swal" ref="SweetAlert" />

  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import cModalViewDispatch from "../Modals/Consumos/cModalViewDispatch.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';

export default {
  components: {
    cModalViewDispatch,
    SweetAlert,
  },

  data() {
    return {
      swal: null,
      filter: {
        begindate: null,
        enddate: null,
        search: "",
      },
      cpData: [],
      noRecordsMessage: "No hay registros",
      loading: {
        excel: false,
        pdf: false,
      },
      modalViewDispatch: {
        title: "",
        modal_form: false,
        data: [],
      },
    };
  },

  created() {
    moment.locale("es");

    this.filter.begindate =
      moment().format("L").substr(6, 4) +
      "-" +
      moment().format("L").substr(3, 2) +
      "-01";

    this.filter.enddate =
      moment().format("L").substr(6, 4) +
      "-" +
      moment().format("L").substr(3, 2) +
      "-" +
      moment().format("L").substr(0, 2);
  },

  computed: {
    filteredData() {
      if (!this.filter.search || this.filter.search.trim() === "") {
        return this.cpData;
      }
      const search = this.filter.search.toLowerCase();
      return this.cpData.filter((item) => {
        if (!item.product) return false;
        const name = item.product?.subsubcategorie?.name?.toLowerCase() || "";
        return name.includes(search);
      });
    },

    totals() {
      return this.filteredData.reduce(
        (acc, item) => {
          const qty = item.avg_quantity || 0;
          const dev = item.avg_devolution || 0;
          acc.quantity += qty;
          acc.devolution += dev;
          acc.consumed += qty - dev;
          return acc;
        },
        { quantity: 0, devolution: 0, consumed: 0 }
      );
    },
  },

  methods: {
    ...mapActions(["get", "post"]),

    returnHome() {
      this.$emit("returnHome");
    },

    mtdGetData() {
      this.post({
        url: this.$store.getters.get__url + "/Pharmacy/consumo",
        token: this.$store.getters.get__token,
        params: this.filter,
      })
        .then((response) => {
          this.cpData = response || [];
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getStock(item) {
      if (!item.product || !item.product.stock) return 0;
      return item.product.stock.reduce(
        (total, s) => total + Number(s.quantity || 0),
        0
      );
    },

    // ─── DESCARGA GENÉRICA ────────────────────────────────────────────────────
    downloadFile(endpoint, filename, loadingKey) {
      this.loading[loadingKey] = true;

      const baseUrl = this.$store.getters.get__url;

      fetch(`${baseUrl}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.getters.get__token}`,
        },
        body: JSON.stringify(this.filter),
      })
        .then((res) => {
          if (!res.ok) {
            return res.text().then((text) => {
              throw new Error(text || "Error del servidor");
            });
          }
          return res.blob();
        })
        .then((blob) => {
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.download = filename;
          a.click();
          URL.revokeObjectURL(a.href);
          this.$refs.SweetAlert.showSuccess("DESCARGA CORRECTA");
        })
        .catch((err) => {
          console.error("Error al descargar:", err);
          this.$refs.SweetAlert.showError(err.message || "No se pudo generar el archivo.");
        })
        .finally(() => {
          this.loading[loadingKey] = false;
        });
    },

    // ─── EXCEL (backend) ──────────────────────────────────────────────────────
    exportExcel() {
      this.downloadFile(
        "/Pharmacy/consumoExcel",
        `Consumos_${this.filter.begindate}_${this.filter.enddate}.xlsx`,
        "excel"
      );
    },

    // ─── PDF (backend) ────────────────────────────────────────────────────────
    exportPDF() {
      this.downloadFile(
        "/Pharmacy/consumoPDF",
        `Consumos_${this.filter.begindate}_${this.filter.enddate}.pdf`,
        "pdf"
      );
    },


    // ─── IMPRIMIR (frontend) ──────────────────────────────────────────────────
    printTable() {
      const periodText = `Período: ${this.filter.begindate} al ${this.filter.enddate}`;

      const rows = this.filteredData
        .map((item, index) => {
          const consumo =
            (item.avg_quantity || 0) - (item.avg_devolution || 0);
          return `
            <tr>
              <td>${index + 1}</td>
              <td style="text-align:left">${item.product?.subsubcategorie?.name || "-"}</td>
              <td style="text-align:left">${item.product?.subsubcategorie?.group?.name || "Sin Forma"}</td>
              <td>${item.product?.brand?.name || "-"}</td>
              <td style="text-align:left">${item.product?.molecule || "-"}</td>
              <td style="text-align:left">${item.product?.commercial || "-"}</td>
              <td>${item.product?.presentation || "-"}</td>
              <td>${this.getStock(item)}</td>
              <td>${item.avg_quantity || 0}</td>
              <td>${item.avg_devolution || 0}</td>
              <td>${consumo}</td>
            </tr>`;
        })
        .join("");

      const totalRow = `
        <tr style="background:#f5e6ee; font-weight:bold;">
          <td colspan="8" style="text-align:right;">TOTAL</td>
          <td>${this.totals.quantity}</td>
          <td>${this.totals.devolution}</td>
          <td>${this.totals.consumed}</td>
        </tr>`;

      const win = window.open("", "_blank");
      win.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>Consumos</title>
          <style>
            body  { font-family: Arial, sans-serif; font-size: 10px; margin: 15px; }
            h2    { text-align: center; color: #900052; margin-bottom: 4px; font-size: 13px; }
            p     { text-align: center; color: #555; margin-bottom: 10px; font-size: 9px; }
            table { width: 100%; border-collapse: collapse; }
            th    { background: #900052; color: #fff; padding: 4px 6px; text-align: center; font-size: 9px; }
            td    { border: 1px solid #ccc; padding: 3px 5px; text-align: center; font-size: 9px; }
            @media print {
              @page { size: landscape; margin: 8mm; }
              body  { margin: 0; }
            }
          </style>
        </head>
        <body>
          <h2>REPORTE DE CONSUMOS</h2>
          <p>${periodText}</p>
          <table>
            <thead>
              <tr>
                <th>N°</th><th>NOMBRE</th><th>FORMA FARMACEUTICA</th><th>MARCA</th><th>MOLECULA</th>
                <th>COMERCIAL</th><th>PRESENTACION</th><th>STOCK</th>
                <th>DESPACHOS</th><th>DEVOLUCIONES</th><th>CONSUMOS</th>
              </tr>
            </thead>
            <tbody>${rows}${totalRow}</tbody>
          </table>
          <script>window.onload = function(){ window.print(); window.close(); }<\/script>
        </body>
        </html>
      `);
      win.document.close();
    },

    // ─── MODAL ────────────────────────────────────────────────────────────────
    openModalViewDispatch(payload, pos) {
      this.post({
        url: this.$store.getters.get__url + "/Pharmacy/dispatchAndDevolution",
        token: this.$store.getters.get__token,
        params: { payload, filter: this.filter },
      })
        .then((response) => {
          this.modalViewDispatch = {
            title: "Despachos y Devoluciones",
            modal_form: true,
            data: response.data,
          };
        })
        .catch((error) => {
          console.error(error);
        });
    },

    mtdCloseModalViewDispatch() {
      this.modalViewDispatch = { title: "", modal_form: false, data: [] };
    },
  },
};
</script>

<style>
.border-main {
  border-color: #900052 !important;
}

.table-container {
  max-height: calc(100vh - 290px);
  min-height: calc(100vh - 290px);
  height: calc(100vh - 290px);
  overflow-y: auto;
}

.custom-table {
  border-collapse: separate !important;
  border-spacing: 0;
}

.custom-table th,
.custom-table td {
  font-size: 11px;
  white-space: normal !important;
  word-break: break-word;
}

.font-size-ca {
  font-size: 14px !important;
}


/* HEADER FIJO */
.header-sticky th {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #900052;
  color: #fff;
}

.table tbody tr:hover td {
  background-color: rgba(144, 0, 82, 0.1) !important;
}

@media print {
  .no-print {
    display: none !important;
  }
}
</style>